import { gql } from '@apollo/client';
import { TICKET_COMMENTS_FRAGMENT } from '@/entities/support/@x/clinic';

const CREATE_TICKET_COMMENT = gql`
  mutation createTicketComment($input: CreateTicketCommentInput!) {
    createTicketComment(input: $input) {
      isSuccess
      message
      ticketComment {
        ...TicketCommentsFragment
      }
    }
  }

  ${TICKET_COMMENTS_FRAGMENT}
`;

export default CREATE_TICKET_COMMENT;
